<template>
    <svg
        class="icon-attention fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1,18.21H11v-2h2Zm0-3.89H11V4.87h2Z" /></svg>
</template>